import styled from 'styled-components';
import { colors } from './theme';
export const StyledContainer = styled.div `
  position: relative;
  max-width: ${props => props.width || 1200}px;
  margin: 0 auto;
`;
export const StyledFlex = styled.div `
  display: flex;
  flex-direction: ${props => props.direction};
  justify-content: ${props => props.justifyContent};
  align-items: ${props => props.alignItems};

  > div {
    // Fixes issue with collapsing flex children
    flex-basis: auto;
  }
`;
export const StyledBorder = styled.div `
  border-bottom: 1px solid ${colors.lightGrey};
`;
//# sourceMappingURL=common.js.map